import { useParams } from "@tanstack/react-router";
import { useProject } from "../../api/queries";
import { CardStatus } from "../../components/cards/CardStatus";
import { ProjectBoardCard } from "./ProjectBoardCard";
import { ProjectCustomersCard } from "./ProjectCustomersCard";
import { ProjectLinksCard } from "./ProjectLinksCard";
import { ProjectMemosCard } from "./ProjectMemosCard";
import { ProjectOverviewCard } from "./ProjectOverviewCard";
import { ProjectParticipantsCard } from "./ProjectParticipantsCard";
import { ProjectRelationsCard } from "./ProjectRelationsCard";

/**
 * プロジェクトの画面。ホームと同じ見せ方にする(ユーザー要望 2026-10-22): カードの枠はやめ、
 * 見出しの下線と、列の区切り線で区切る(HomeSection)。3 列(1280px 以上):
 *   左 = プロジェクトの情報(概要・顧客・参加者) / 中央 = 「まずはここを見よう」ボード・外部リンク・関連プロジェクト /
 *   右 = プロジェクトのメモ(SPEC §13.6)。幅はホームと同じく、左 26rem、中央 2: メモ 1。
 * 1024〜1279px は 2 列にし、メモは中央の列の下に置く。1024px 未満は、この並びのまま縦に積む。
 * ホームと違い、項目の多さがプロジェクトごとに違うので、画面全体でスクロールする。
 */
export function ProjectPage() {
  const { projectId } = useParams({ from: "/app/projects/$projectId" });
  const project = useProject(projectId);

  if (!project.data) {
    return (
      <div className="max-w-md">
        <CardStatus
          isPending={project.isPending}
          isError={project.isError}
          refetch={() => project.refetch()}
        />
      </div>
    );
  }
  const p = project.data.project;
  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-xl font-semibold">{p.name}</h2>
      <div className="grid gap-y-8 lg:grid-cols-[26rem_minmax(0,1fr)] xl:grid-cols-[26rem_minmax(0,2fr)_minmax(0,1fr)]">
        <div className="flex min-w-0 flex-col gap-8 lg:row-span-2 lg:pr-10 xl:row-span-1">
          <ProjectOverviewCard project={p} />
          <ProjectCustomersCard project={p} />
          <ProjectParticipantsCard project={p} />
        </div>
        <div className="flex min-w-0 flex-col gap-8 lg:border-l lg:pl-10 xl:pr-10">
          <ProjectBoardCard project={p} />
          <ProjectLinksCard project={p} />
          <ProjectRelationsCard project={p} />
        </div>
        <ProjectMemosCard project={p} className="lg:border-l lg:pt-8 lg:pl-10 xl:pt-0" />
      </div>
    </div>
  );
}
